import { render, staticRenderFns } from "./metadataViewer.vue?vue&type=template&id=31fc7eb4&scoped=true"
import script from "./metadataViewer.vue?vue&type=script&lang=ts"
export * from "./metadataViewer.vue?vue&type=script&lang=ts"
import style0 from "./metadataViewer.vue?vue&type=style&index=0&id=31fc7eb4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fc7eb4",
  null
  
)

export default component.exports